import catalogJson from '../../../contracts/role-catalog.v1.json';

/** Contrat de rôles partagé poste / serveurs (contracts/role-catalog.v1.json). */
export interface RoleCatalogContract {
  version: number;
  roles: readonly string[];
  read: Record<string, readonly string[]>;
  paie_views: readonly string[];
  view_profiles: Record<string, readonly string[]>;
  module_data_write: {
    base: readonly string[];
    comptable: { namespaces: readonly string[]; prefixes: readonly string[] };
    salarie: { namespaces: readonly string[] };
  };
}

export const ROLE_CATALOG: RoleCatalogContract = catalogJson;

/** Le rôle lit-il les données de paie / RH (salariés, bulletins, congés) ? Même règle que le serveur (`read.paie`). */
export function roleCanReadPaie(role: string | null | undefined): boolean {
  return role !== undefined && role !== null && (ROLE_CATALOG.read['paie'] ?? []).includes(role);
}
